export default {
    user (state) {
        return state.user
    },
    error (state) {
        return state.error
    },
    isUserLoggedIn (state) {
        return state.user
    },
    getBillingHistory (state) {
        return state.billingHistory
    },
    getDefaultImages (state) {
        return state.defaultImagesList
    },
    getPaypalToken (state) {
        return state.paypalToken
    },
    getCreditCardInfo (state) {
        return state.creditCardInfo
    },
    getUserPlaylists (state) {
        return state.userPlaylists
    },
    getUserSharedPlaylists (state) {
        return state.userSharedPlaylists
    },
    getUserPlaylistsWithVideos (state) {
        return state.userPlaylistsWithVideos
    },
    getValidationStatusError (state) {
        return state.validationStatusError
    },
    getCorporationPinnedMsgs (state) {
        return state.corporationPinnedMsgs
    },
    getCropUserSharedVideos (state) {
        return state.corpUserSharedVideos
    },
    getUserPlaylistsProfile (state) {
        return state.userPlaylistsProfile
    },
    getUserProgressProfile (state) {
        return state.userProgressProfile
    },
    getUserEmailPreferences (state) {
        return state.userEmailPreferences
    }
}



// WEBPACK FOOTER //
// ./src/store/users/getters.js